import { useState } from 'react';
import { faqs } from '@/mocks/faqs';
import FadeInSection from '@/components/base/FadeInSection';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <FadeInSection>
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              关于第一版主，你可能想了解的问题
            </p>
          </div>
        </FadeInSection>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <FadeInSection key={index} delay={index * 60}>
              <div
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center text-foreground-400">
                    <i
                      className={`ri-${
                        openIndex === index ? 'subtract' : 'add'
                      }-line text-lg transition-transform duration-200`}
                    ></i>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}